import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IDashboardLastUpdateResponse } from '../types';
import {
  DASHBOARD_LAST_UPDATE_QUERY_KEY,
  DASHBOARD_LAST_UPDATE_URL,
  DASHBOARD_PERMISSIONS,
} from '../constants';

export default function useDashboardLastUpdateQuery(merchant: Ref<number | undefined>): IContextQueryResult<IDashboardLastUpdateResponse, Error, string> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardLastUpdateResponse, Error, string>({
    queryKey: [DASHBOARD_LAST_UPDATE_QUERY_KEY, merchant],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_LAST_UPDATE_URL, {
      signal,
      queryParams: { merchant: merchant.value },
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_LAST_UPDATE,
    }),
    select: (res) => res.last_update || res.date_update_statistic || '',
    placeholderData: keepPreviousData,
    enabled: computed(() => !!merchant.value),
  });
}
